import { useFormState } from 'react-final-form'
import { Prompt } from 'react-router'

interface FormPromptProps {
  condition?: boolean
  ignorePromptWhenSubmitting?: boolean
  disabled?: boolean
}

export function FormPrompt(props: Readonly<FormPromptProps>) {
  const { condition, ignorePromptWhenSubmitting, disabled } = props
  const { pristine, submitSucceeded, submitting, dirtySinceLastSubmit } = useFormState({
    subscription: {
      pristine: true,
      submitSucceeded: true,
      dirtySinceLastSubmit: true,
      submitting: true,
    },
  })

  if (ignorePromptWhenSubmitting && submitting) return null

  return (
    <Prompt when={((!pristine && (!submitSucceeded || dirtySinceLastSubmit)) || condition) && !disabled} message='' />
  )
}

FormPrompt.defaultProps = {
  condition: false,
} as FormPromptProps
